const SESSION_RECORDING_EVENTS = Object.freeze({
  incentiveOfferClick: "snow_incentive_offer_click",
  incentiveContinueClick: "snow_incentive_continue_click",
  incentivePanelClick: "snow_incentive_panel_click",
  signupNoFreeClick: "snow_signup_no_free_click",
})

export default SESSION_RECORDING_EVENTS
